/**
 * Sticky header
 */
document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('.section-header');

	if (!header) return;

	const headerOffset = header.offsetTop;

	const handleScroll = () => {
		if (window.scrollY > headerOffset) {
			header.classList.add('header-sticky');
		} else {
			header.classList.remove('header-sticky');
		}
	};

	handleScroll();

	window.addEventListener('scroll', handleScroll, {
		passive: true,
	});
});
/** End sticky header */

window.addEventListener('DOMContentLoaded', function () {
	/**
	 * Focus dropdown search box
	 */
	const dropdownSearch = document.querySelector('.header-search__type-dropdown');

	if (dropdownSearch) {
		let focusTimer = null;

		dropdownSearch.addEventListener('focusin', () => {
			clearTimeout(focusTimer);

			focusTimer = setTimeout(() => {
				if (dropdownSearch.contains(document.activeElement)) {
					document.body.classList.add('focus-dropdown-search');
				}

				const container = document.querySelector('predictive-search');

				trapFocus(container, container);
			}, 400);
		});

		dropdownSearch.addEventListener('focusout', () => {
			clearTimeout(focusTimer);
		});

		document.addEventListener('click', (event) => {
			if (!dropdownSearch.contains(event.target)) {
				document.body.classList.remove('focus-dropdown-search');
			}
		});
	}

	const predictiveSearch = document.querySelector('predictive-search');

	if (predictiveSearch) {
		predictiveSearch.addEventListener('focusout', (e) => {
			const nextFocus = e.relatedTarget;

			if (!predictiveSearch.contains(nextFocus)) {
				document.body.classList.remove('focus-dropdown-search');
			}
		});
	}
});

/**
 * Set variable style for body
 */

window.addEventListener('DOMContentLoaded', function () {
	/**
	 * Toogle category mobile
	 */

	const itemCatParent = document.querySelectorAll('.mobile-parent__item');
	itemCatParent.forEach((item) => {
		item.addEventListener('click', () => {
			item.closest('.megamenu-category-item').classList.toggle('active');
		});
	});
});

/**
 * Section lady load
 */
function secsionLadyLoad() {
	let parentSection = '';
	const section = document.querySelector('[data-ladyload="true"]');

	if (section) {
		parentSection = section.closest('.shopify-section');
	}

	if (section) {
		const elementId = section.getAttribute('id');
		const sectionId = elementId.substring(16);
		const urlFetchSectionId = window.Shopify.routes.root + '?section_id=' + sectionId;

		if (!section.classList.contains('loaded')) {
			section.classList.add('loaded');

			fetch(urlFetchSectionId)
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					setTimeout(() => {
						sectionElement = responseHTML.querySelector('section[id^="shopify-section-"]');

						section.innerHTML = sectionElement.innerHTML;
						section.querySelectorAll('script').forEach((oldScriptTag) => {
							const newScriptTag = document.createElement('script');
							Array.from(oldScriptTag.attributes).forEach((attribute) => {
								newScriptTag.setAttribute(attribute.name, attribute.value);
							});
							newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
							oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
						});

						section.setAttribute('data-ladyload', 'false');

						/**
						 * Fix lazyload image with RTL layout
						 */
						if (parentSection && document.querySelector('body').classList.contains('layout-rtl')) {
							const imagesLazy = parentSection.querySelectorAll('img');

							imagesLazy.forEach((image) => {
								if (image.getAttribute('loading') == 'lazy') {
									image.setAttribute('loading', 'loaded');
								}
							});
						}
					}, 50);
				})
				.finally(() => {
					if (document.querySelector('[data-fancybox]')) {
						Fancybox.bind('[data-fancybox="gallery"]', {});
					}
				});
		}
	}
}

/**
 * Fix image lazyload with swipper slider and RTL layout
 */

const interSection = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.intersectionRatio > 0) {
			entry.target.querySelectorAll('img').forEach((image) => {
				if (image.getAttribute('loading') == 'lazy') {
					image.setAttribute('loading', 'loaded');
				}
			});
		}
	});
});

if (document.querySelector('body').classList.contains('layout-rtl')) {
	const swiperSlider = document.querySelectorAll('tpt-slider-component');

	swiperSlider.forEach((slider) => {
		interSection.observe(slider);
	});
}

/**
 * End fix image lazyload with swipper slider
 */

/**
 * Dropdown megamenu mobile
 */

class DropdownMegamenuMobile extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.showDropdownMegamenuMobile.bind(this));
	}

	showDropdownMegamenuMobile() {
		const btnDropdown = this;
		const menuItem = btnDropdown.closest('.menu-item');
		menuItem.classList.add('show-dropdown');

		setTimeout(function () {
			menuItem.classList.add('animate');
		}, 10);
	}
}

customElements.define('dropdown-megamenu-item', DropdownMegamenuMobile);

class BackDropdownMegamenu extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.backToMegamenuItem.bind(this));
	}

	backToMegamenuItem() {
		const btnBack = this;
		const menuItem = btnBack.closest('.menu-item');
		menuItem.classList.remove('animate');

		setTimeout(function () {
			menuItem.classList.remove('show-dropdown');
		}, 300);
	}
}

customElements.define('back-to-item', BackDropdownMegamenu);

/**
 * Sticky product add to cart
 */
class StickyProductAddToCart extends HTMLElement {
	constructor() {
		super();

		const btnChangeQty = this.querySelectorAll('.quantity__button');
		const btnStickyAddCart = this.querySelector('.sticky-add-cart');

		btnStickyAddCart.addEventListener('click', this.addToCart);

		btnChangeQty.forEach((btn) => {
			btn.addEventListener('click', this.changeQty);
		});
	}

	changeQty() {
		const inputQty = this.closest('tpt-quantity-input').querySelector('[name="quantity"]');
		const mainInput = document.querySelector('product-info quantity-input [name="quantity"]');
		let stickyInputValue = parseInt(inputQty.value);

		if (this.getAttribute('name') == 'plus') {
			stickyInputValue = stickyInputValue + 1;
		} else {
			if (parseInt(inputQty.value) > 1) {
				stickyInputValue = stickyInputValue - 1;
			}
		}

		inputQty.value = stickyInputValue;
		mainInput.value = stickyInputValue;
	}

	addToCart() {
		this.classList.add('loading');
		document.querySelector('product-info product-form .product-form__submit').click();
	}
}

customElements.define('tpt-quantity-input', StickyProductAddToCart);

function showStickyAddCart() {
	let offsetTop = document.querySelector('product-info product-form').offsetTop;
	let documentTop = document.documentElement.scrollTop;
	const stickyAddCart = document.querySelector('.sticky-button-cart');

	if (documentTop > offsetTop + 400) {
		stickyAddCart.classList.add('active');
		document.body.classList.add('show-sticky-add-cart');
	} else {
		stickyAddCart.classList.remove('active');
		document.body.classList.remove('show-sticky-add-cart');
	}
}

document.addEventListener('scroll', (event) => {
	if (document.querySelector('.sticky-button-cart')) {
		showStickyAddCart();
	}
});

/**
 * Back to top
 */

function toTop() {
	window.scrollTo({ top: 0, behavior: 'smooth' });
}

document.addEventListener('scroll', (event) => {
	const backToTop = document.querySelector('tpt-back-to-top');

	if (backToTop) {
		if (this.scrollY > 800) {
			backToTop.classList.add('active');
		} else {
			backToTop.classList.remove('active');
		}
	}
});

class BackToTop extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', toTop);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			toTop();
		}
	}
}

customElements.define('tpt-back-to-top', BackToTop);

/**
 * Close newsletter
 */
class CloseNewsletter extends HTMLElement {
	constructor() {
		super();

		if (!sessionStorage.getItem('closeNewsletter')) {
			this.closest('.newsletter-popup_button').style.display = 'block';
		}

		this.addEventListener('click', this.closeNewsletter.bind(this));
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.closeNewsletter();
		}
	}

	closeNewsletter() {
		this.closest('.newsletter-popup_button').style.display = 'none';
		sessionStorage.setItem('closeNewsletter', 'true');
	}
}

customElements.define('tpt-close-newsletter', CloseNewsletter);

/**
 * Toggle password
 */

if (!customElements.get('tpt-toggle-password')) {
	customElements.define(
		'tpt-toggle-password',
		class TptTogglePassword extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.togglePassword.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.togglePassword();
				}
			}

			togglePassword() {
				if (this.closest('.input-password').classList.contains('active')) {
					this.closest('.input-password').classList.remove('active');
					this.closest('.input-password').querySelector('input[type="text"]').setAttribute('type', 'password');
					return;
				} else {
					this.closest('.input-password').classList.add('active');
					this.closest('.input-password').querySelector('input[type="password"]').setAttribute('type', 'text');
					return;
				}
			}
		},
	);
}

/**
 * Toggle search mobile
 */

if (!customElements.get('tpt-toggle-search-mobile')) {
	customElements.define(
		'tpt-toggle-search-mobile',
		class TptVisualSearchBanner extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.toggleSearchMobile.bind(this));
			}

			toggleSearchMobile() {
				const headerInputSearch = document.querySelector('.header-search .search__input');

				headerInputSearch.click();
			}
		},
	);
}

/**
 * Fancybox button
 */
if (!customElements.get('tpt-fancybox')) {
	customElements.define(
		'tpt-fancybox',
		class TptFancybox extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showFancyBox.bind(this));
			}

			showFancyBox() {
				console.log('Test...');
				Fancybox.bind('tpt-fancybox', {});
			}
		},
	);
}

/**
 * Banner slide
 */
if (!customElements.get('tpt-banner-slide-item')) {
	customElements.define(
		'tpt-banner-slide-item',
		class TptBannerSlideItem extends HTMLElement {
			constructor() {
				super();

				this.bannerParent = this.closest('tpt-banner-slide');

				this.addEventListener('mouseover', this.bannerSlide.bind(this));
			}

			bannerSlide() {
				if (!this.classList.contains('active')) {
					this.bannerParent.classList.add('loading');

					const bannerItem = this;
					const currentActiveBanner = this.bannerParent.querySelector('tpt-banner-slide-item.active');
					currentActiveBanner.classList.remove('tpt-banner-slide__item-show--info');

					setTimeout(() => {
						currentActiveBanner.classList.remove('active');
						bannerItem.classList.add('active');
					}, 200);

					setTimeout(() => {
						bannerItem.classList.add('tpt-banner-slide__item-show--info');
						this.bannerParent.classList.remove('loading');
					}, 800);
				}
			}
		},
	);
}

const StorageWithExpire = {
	set(key, value, ttl) {
		localStorage.setItem(
			key,
			JSON.stringify({
				value,
				expiredAt: Date.now() + ttl,
			}),
		);
	},

	get(key) {
		const raw = localStorage.getItem(key);
		if (!raw) return null;

		try {
			const { value, expiredAt } = JSON.parse(raw);

			if (Date.now() > expiredAt) {
				localStorage.removeItem(key);
				return null;
			}

			return value;
		} catch {
			localStorage.removeItem(key);
			return null;
		}
	},

	remove(key) {
		localStorage.removeItem(key);
	},
};

if (!customElements.get('tpt-newsletter-popup')) {
	customElements.define(
		'tpt-newsletter-popup',
		class TptNewsletterPopup extends HTMLElement {
			DAY = 24 * 60 * 60 * 1000;

			STORAGE_NO_THANKS = 'tpt_newsletter_popup_no_thanks';
			STORAGE_REMOVE = 'tpt_newsletter_popup_remove';

			NO_THANKS_TTL = 2 * this.DAY;
			REMOVE_TTL = 1 * this.DAY;

			constructor() {
				super();

				this.buttonClose = this.querySelector('.tpt-newsletter-popup__close');
				this.noThanksBtn = this.querySelector('tpt-no-thank');
				this.openBtn = this.querySelector('tpt-open-newsletter-popup');
				this.removeBtn = this.querySelector('tpt-remove-newsletter-popup');

				this.openWrapper = this.openBtn?.closest('.tpt-newsletter-popup__open') || null;
			}

			autoOpen() {
				if (StorageWithExpire.get(this.STORAGE_NO_THANKS)) return;

				const delay = Number(this.dataset.delay) * 1000 || 0;
				setTimeout(() => this.open(), delay);
			}

			open = () => {
				this.classList.add('show');
			};

			close = () => {
				this.classList.remove('show');

				// Remove .tpt-messages
				this.querySelectorAll('.tpt-messages').forEach((el) => {
					el.remove();
				});

				// Remove customer_posted + hash
				const url = new URL(window.location.href);

				console.log(url);

				url.searchParams.delete('customer_posted');
				url.hash = '';

				// Update URL without reload
				window.history.replaceState({}, '', url.toString());
			};

			updateOpenButton() {
				if (!this.openWrapper) return;

				this.openWrapper.classList.toggle('tpt-newsletter-popup__open--visible', !StorageWithExpire.get(this.STORAGE_REMOVE));
			}

			handleNoThanks = () => {
				StorageWithExpire.set(this.STORAGE_NO_THANKS, true, this.NO_THANKS_TTL);

				this.close();
			};

			removeNewsletter = () => {
				this.handleNoThanks();

				StorageWithExpire.set(this.STORAGE_REMOVE, true, this.REMOVE_TTL);

				this.updateOpenButton();
			};

			connectedCallback() {
				this.updateOpenButton();
				this.autoOpen();

				this.buttonClose?.addEventListener('click', this.close);
				this.openBtn?.addEventListener('click', this.open);
				this.noThanksBtn?.addEventListener('click', this.handleNoThanks);
				this.removeBtn?.addEventListener('click', this.removeNewsletter);
			}
		},
	);
}

/**
 * Update label sticky cart product page
 */

function updateStickyCartLabel() {
	if (document.querySelector('.sticky-button-cart') && document.querySelector('.main-product-section variant-selects')) {
		const productVariants = document.querySelectorAll('.main-product-section variant-selects fieldset.product-form__input');
		const variantLabelContainer = document.querySelectorAll('.sticky-cart_variants');

		variantLabelContainer.forEach((variantContent) => {
			variantContent.innerHTML = '';
		});

		productVariants.forEach((variant) => {
			const variantLabel = variant.querySelector('.form__label');
			variantLabelContainer.forEach((variantContent) => {
				variantContent.insertAdjacentHTML('beforeend', '<div class="variant-label">' + variantLabel.innerHTML + '</div>');
			});
		});
	}
}

updateStickyCartLabel();

/**
 * Validate email input contact form
 */
document.querySelectorAll('form[action*="/contact"]').forEach((form) => {
	const emailInput = form.querySelector('input[name="contact[email]"]');
	if (!emailInput) return;

	const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

	form.addEventListener(
		'submit',
		function (e) {
			const value = emailInput.value.trim();

			emailInput.setCustomValidity('');

			if (!value || !regex.test(value)) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				emailInput.setCustomValidity('Please enter a valid email (example@email.com)');
				emailInput.reportValidity();

				return false;
			}
		},
		true,
	);

	emailInput.addEventListener('input', () => {
		emailInput.setCustomValidity('');
	});
});

/**
 * Move block size chart to option size
 */

if (!customElements.get('tpt-sizechart')) {
	customElements.define(
		'tpt-sizechart',
		class TptSizechart extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.moveIntoSizeLabel();
			}

			moveIntoSizeLabel() {
				const sizeOption = document.querySelector('[name="options[Size]"]');

				if (!sizeOption) return;

				const productInput = sizeOption.closest('.product-form__input');

				if (!productInput) return;

				const label = productInput.querySelector('.form__label');

				if (!label) return;

				label.appendChild(this);
			}
		},
	);
}

/**
 * View more item menu
 */

if (!customElements.get('tpt-view-more-menu-item')) {
	customElements.define(
		'tpt-view-more-menu-item',
		class TptViewMoreMenu extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showMoreMenu.bind(this));
			}

			showMoreMenu() {
				this.classList.toggle('active');
			}
		},
	);
}
